import { AfterViewInit, ChangeDetectorRef, Component, EventEmitter, OnInit, Output, QueryList, ViewChild, ViewChildren, inject, DestroyRef, ChangeDetectionStrategy } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import {UntypedFormArray, UntypedFormBuilder, UntypedFormGroup, Validators} from '@angular/forms';
import {CreateDisclosureSharedService, DropDownType, EntityNameChange} from '../../create-disclosure-shared.service';
import {DSTConsolGroup, TemplateHeaderComponent} from '../template-header/template-header.component';
import {TemplateHeaderService} from '../template-header/template-header.service';
import {DSTEntityDetails, TemplateLeidSelectorComponent} from '../template-leid-selector/template-leid-selector.component';
import {DSTSavePayload} from '../../dst-dynamic-component-resolver.service';
import {TrackerTabsService, TrackerTabState} from '../../../../tracker-tabs.service';
import { HttpErrorResponse } from '@angular/common/http';
import {DSTFormState, StmtAttrData, StmtData} from '../../../../../shared/models/dst-form-state.model';
import {DSTSharedService} from '../../../../../shared/dst-shared.service';
import {stripAmountFormatting} from '../../dst-amount.util';
import {toSaveString, safeEntityField, safeEntityId} from '../../dst-save.util';

import { safeJsonInput } from '../../../../../../shared/_utils/safe-json-input';
@Component({
    selector: 'dst-template-sec351-id184',
    templateUrl: './template-sec351-id184.component.html',
    styleUrls: ['../template-shared.scss', './template-sec351-id184.component.scss'],
    standalone: false,
  changeDetection: ChangeDetectionStrategy.Eager,
})
export class TemplateSec351Id184Component implements OnInit, AfterViewInit {
  private readonly destroyRef = inject(DestroyRef);


  // remove me after commit

  @ViewChild('mainLeidSelector')
  private mainLeidSelector!: TemplateLeidSelectorComponent;

  @ViewChild(TemplateHeaderComponent)
  private headerComponent!: TemplateHeaderComponent;

  @ViewChildren(TemplateLeidSelectorComponent)
  private leidComponents!: QueryList<TemplateLeidSelectorComponent>;

  @Output('onSave') onSave: EventEmitter<DSTSavePayload> = new EventEmitter<DSTSavePayload>();
  @Output('onCancel') onCancel: EventEmitter<null> = new EventEmitter<null>();

  attMap: any = {};
  statementId: string = '';
  startLoader: boolean = false;
  form184!: UntypedFormGroup;
  selectedOption!: string;
  transferor!: DSTEntityDetails | null;
  transferee!: DSTEntityDetails | null;
  branchEntity!: DSTEntityDetails | null;
  targetLEID!: DSTEntityDetails | null;
  beginDate!: Date;
  endDate!: Date;
  defaultDate: any = '';
  dcnId!: number;
  liquidationDate2: any = '';
  liquidationDate3: any = '';
  liquidationDate4: any = '';
  isSection304Related: boolean | undefined;
  formInvalid: boolean = true;
  defaultText: string = 'test';
  importationProp: string = '';
  lossDupProp: string = '';
  gainLossAffectedProp: string = '';
  sharesBeforeTransfer: string = '';
  sharesAfterTransfer: string = '';
  stockBeforeTransfer: string = '';
  stockAfterTransfer: string = '';

  propertyValBasisOptions: any = [{data: []}];
  selectedBasis: number = -1;
  selectedBasisName: string = '';
  selectedBasisItem: any = null;
  selectedCurrency: number = 0;
  selectedCurrency2: number = 0;
  currencySelected3: number = 0;
  selectedCurrencyItem: any = null;
  selectedCurrencyItem2: any = null;
  selectedCurrencyItem3: any = null;

  currencyOptions: any = [{data: []}];
  currencyOptions2: any = [{data: []}];
  currencyOptions3: any = [{data: []}];

  stockType: any = [{data: []}];
  stockType304: any = [{data: []}];
  selectedStockType: number = -1;
  selectedStockTypeItem: any = null;
  selectedStockType304: number = 0;
  selectedStockType304Item: any = null;
  controlNum: string = 'None.';

  section304ExchangeType: any[] = [{data: []}];
  selectedExchangeType: number = 0;
  selectedExchangeTypeItem: any = null;

  amtFromSigTransferor: string = '';
  amtInExchangeFor: string = '';
  Para: string = '';
  info: string = '';

  showTotal: boolean = false;
  showImport: boolean = false;
  totalCalc: number = 0;

  showDREMsg: boolean = false;
  DREMsg: string = '';
  entityNameChangeOnDate: boolean = false;

  headerOptions: any[] = [
    {value: 0, label: '-'},
    {value: 1, label: '(a)'}
  ];
    nameChangeChecked: boolean = false;

  constructor(private formBuilder: UntypedFormBuilder,
              private dstSharedService: DSTSharedService,
              private sharedService: CreateDisclosureSharedService,
              private trackerTabsService: TrackerTabsService,
              private headerService: TemplateHeaderService,
              private cdref: ChangeDetectorRef) {
    this.isSection304Related = undefined;
  }

  get additionalPropsDetails(): UntypedFormArray {
    return this.form184.get('propertiesDetails')?.get('additionalPropsDetails') as UntypedFormArray;
  }

  get liabilityDetails(): UntypedFormArray {
    return this.form184.get('liabilitiesAssumed')?.get('liabilityDetails') as UntypedFormArray;
  }

  ngOnInit(): void {

    // default values for testing only
    this.beginDate = new Date(1700, 0, 1);
    this.endDate = new Date((this.sharedService.getActiveFormState()?.taxYear || 2021) + 2, 11, 31);
    // this.defaultDate = new Date(this.sharedService.getActiveFormState()?.taxYear || 2020, 0, 1);
    // this.liquidationDate2 = new Date(this.sharedService.getActiveFormState()?.taxYear || 2020, 0, 1);
    // this.liquidationDate3 = new Date(this.sharedService.getActiveFormState()?.taxYear || 2020, 0, 1);
    // this.liquidationDate4 = new Date(this.sharedService.getActiveFormState()?.taxYear || 2020, 0, 1);
    this.form184 = this.formBuilder.group({
      header: this.formBuilder.group({
        consolGroup: ['', Validators.required],
        options: ['']
      }),
      // transferorDetails: this.formBuilder.group({
      // transferors: this.formBuilder.array([
      //   this.formBuilder.control('')
      // ]),
      // transferor: ['', Validators.required],
      // transferee: ['', Validators.required]
      // }),
      datesTransfer: this.formBuilder.group({
        tran1: [''],
        tran2: [''],
        // default date setup here is not working in appkit date picker, use ngModel instead
        dateTransfer1: [, Validators.required],
        dateTransfer2: [],
        dateTransfer3: []
      }),
      propertiesDetails: this.formBuilder.group({
        importationProp: [''],
        lossDupProp: [''],
        gainLossAffectedProp: [''],
        propertyValBasis: ['', Validators.required],
        currency1: ['', Validators.required],
        currency2: ['', Validators.required],
        additionalPropsDetails: this.formBuilder.array([
          this.formBuilder.group({
            description: [''],
            transferorBasis: [''],
            fairMarketVal: ['']
          })
        ]),
        shareChangeSec: this.formBuilder.group({
          sharesBeforeTransfer: [''],
          sharesAfterTransfer: [''],
          stockBeforeTransfer: [''],
          stockAfterTransfer: [''],
          stockType: [''],
          section304Details: this.formBuilder.group({
            amtFromSigTransferor: [''],
            stockType304: [''],
            exchangeType: [''],
            amtInExchangeFor: [''],
            currencyType: [''],
            comment: ['']
          })
        })
      }),
      privateLetterRul: this.formBuilder.group({
        dateIssued: [''],
        controlNum: ['']
      }),
      liabilitiesAssumed: this.formBuilder.group({
        liabilityDetails: this.formBuilder.array([
          this.formBuilder.group({
            description: [''],
            amount: ['']
          })
        ]),
        suppInfo: this.formBuilder.group({
          info: ['']
        }),
        // branchInfo: this.formBuilder.group({
        //   branchLEID: ['']
        // })
      })
    });
    this.sharedService.getBasisDropdown().pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe((data: DropDownType[]) => {
        console.log(data);
        data.forEach(element => {
          this.propertyValBasisOptions[0].data.push({
            value: element.id,
            text: element.text,
            selected: false //(element.id === 3) // default to GAAP
          });
        });
        this.propertyValBasisOptions = safeJsonInput<any>(JSON.stringify(this.propertyValBasisOptions), null, 'template-sec351-id184.parse1');
        // const gaapExist: boolean = this.propertyValBasisOptions[0].data.findIndex((d: any) => d.value === 3) >= 0;
        // if (gaapExist) {
        //   this.selectedBasis = 3;
        //   this.selectedBasisName = 'GAAP';
        // }
      }, () => {

      }, () => {
        if (this.attMap['Basis']) {
          const updatedData = this.updateDropdownList(this.propertyValBasisOptions, this.attMap['Basis'][0]);
          this.propertyValBasisOptions = updatedData.dropdownData;
          this.propertyValBasisOptions = safeJsonInput<any>(JSON.stringify(this.propertyValBasisOptions), null, 'template-sec351-id184.parse2');
          this.selectedBasis = updatedData.index;
          this.selectedBasisItem = this.propertyValBasisOptions[0]?.data?.find((i: any) => i.selected) || null;
        }
      });

    this.sharedService.getStockType().pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe((data: DropDownType[]) => {
        console.log(data);
        data.forEach(element => {
          const value = (element as any).id ?? (element as any).value;
          const text = (element as any).text ?? (element as any).label ?? '';
          this.stockType[0].data.push({
            value,
            text,
            label: text
          });
          this.stockType304[0].data.push({
            value,
            text,
            label: text
          });
        });
      }, () => {

      }, () => {
        if (this.attMap['StockType']) {
          const updatedData = this.updateDropdownList(this.stockType, this.attMap['StockType'][0]);
          this.stockType = updatedData.dropdownData;
          this.selectedStockType = updatedData.index;
          this.selectedStockTypeItem = this.stockType[0]?.data?.find((i: any) => i.selected) || null;
        }

        if (this.attMap['StockType304']) {
          const updatedData = this.updateDropdownList(this.stockType304, this.attMap['StockType304'][0]);
          this.stockType304 = updatedData.dropdownData;
          this.selectedStockType304 = updatedData.index;
          this.selectedStockType304Item = this.stockType304[0]?.data?.find((i: any) => i.selected) || null;
        }

      });

    this.sharedService.getLiquidationStateDropdown(2).pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe((data: DropDownType[]) => {
        console.log(data);
        data.forEach(element => {
          this.section304ExchangeType[0].data.push({
            value: element.id,
            text: element.text
          });
        });
      }, () => {

      }, () => {
        if (this.attMap['TransfereesNote']) {
          const updatedData = this.updateDropdownList(this.section304ExchangeType, this.attMap['TransfereesNote'][0]);
          this.section304ExchangeType = updatedData.dropdownData;
          this.selectedExchangeType = updatedData.index;
          this.selectedExchangeTypeItem = this.section304ExchangeType[0]?.data?.find((i: any) => i.selected) || null;
        }

      });

    this.loadCurrency();
  }

  private loadCurrency() {
    this.sharedService.getCurrencyDropdown().pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe((data: DropDownType[]) => {
        data.forEach((element, index) => {
          this.currencyOptions[0].data.push({
            value: element.id,
            text: element.text,
            index: index,
          });
          this.currencyOptions2[0].data.push({
            value: element.id,
            text: element.text,
            index: index,
          });
          this.currencyOptions3[0].data.push({
            value: element.id,
            text: element.text,
            index: index,
          });
        });
        const usdIndex: number = data.findIndex((c: any) => c.id === 84);
        if (usdIndex >= 0) {
          this.currencyOptions[0].data[usdIndex].selected = true;
          this.currencyOptions2[0].data[usdIndex].selected = true;
          this.currencyOptions = safeJsonInput<any>(JSON.stringify(this.currencyOptions), null, 'template-sec351-id184.parse3');
          this.currencyOptions2 = safeJsonInput<any>(JSON.stringify(this.currencyOptions2), null, 'template-sec351-id184.parse4');
          this.selectedCurrency = this.currencyOptions[0].data[usdIndex].value;
          this.selectedCurrency2 = this.currencyOptions2[0].data[usdIndex].value;
          this.selectedCurrencyItem = this.currencyOptions[0].data[usdIndex];
          this.selectedCurrencyItem2 = this.currencyOptions2[0].data[usdIndex];
        }
      }, () => {
      }, () => {
        if (this.attMap['Currency']) {
          this.attMap['Currency'].forEach((element: any, index: number) => {
            switch (index) {
              case 0:
                let updatedData = this.updateDropdownList(this.currencyOptions, element);
                this.currencyOptions = updatedData.dropdownData;
                this.selectedCurrency = updatedData.index;
                this.selectedCurrencyItem = this.currencyOptions[0]?.data?.find((i: any) => i.selected) || null;
                break;
              case 1:
                const updatedData2 = this.updateDropdownList(this.currencyOptions2, element);
                this.currencyOptions2 = updatedData2.dropdownData;
                this.selectedCurrency2 = updatedData2.index;
                this.selectedCurrencyItem2 = this.currencyOptions2[0]?.data?.find((i: any) => i.selected) || null;
                break;
              case 2:
                const updatedData3 = this.updateDropdownList(this.currencyOptions3, element);
                this.currencyOptions3 = updatedData3.dropdownData;
                this.currencySelected3 = updatedData3.index;
                this.selectedCurrencyItem3 = this.currencyOptions3[0]?.data?.find((i: any) => i.selected) || null;
                break;
            }
          });
        }
      });
  }

  updateDropdownList(currentOptions: any, element: string) {
    const updateList: any[] = [];
    let selectedIndex = -1;
    currentOptions[0].data.forEach((el: any, index: number) => {
      const elValue = el.value;
      const selected = String(element) === String(elValue);
      if (selected) {
        updateList.push({
          value: elValue,
          text: el.text ?? el.label ?? '',
          label: el.label ?? el.text ?? '',
          index: index,
          selected: true,
        });
        selectedIndex = elValue;
      } else {
        updateList.push({
          value: elValue,
          text: el.text ?? el.label ?? '',
          label: el.label ?? el.text ?? '',
          index: index,
        });
      }
    });
    return {dropdownData: [{data: updateList}], index: selectedIndex};
  }

  ngAfterViewInit(): void {
    this.loadStmtData();
  }

  private loadStmtData(): void {
    const data = this.sharedService.getFormData(184);
    if (data) {
      this.statementId = data.isCopiedStatement ? '' : data.statementid.toString();
      this.dcnId = parseInt(data.dcnid!);

      setTimeout(() => {
        this.leidComponents.toArray().forEach((element: TemplateLeidSelectorComponent, index: number) => {
          switch (index) {
            case 0:
              element.fillLEID(data.secondaryleid);
              break;
            case 1:
              element.fillLEID(data.primaryleid);
              break;
          }
        });
      },1000);

      this.populateFields(data);

      this.loadCurrency();
    } else if (this.sharedService.leid !== '') {
      this.statementId = (this.trackerTabsService.getActiveTrackerTab()?.getActiveFormState().statementId!).toString();
      const is304 = this.trackerTabsService.getActiveTrackerTab()?.getActiveFormState().is304;
      (is304) && (this.isSection304Related = true);
      const formId = this.trackerTabsService.getActiveTrackerTab()?.getActiveFormState().formId;
      const taxYear = (this.sharedService.getActiveFormState()?.taxYear || 2020).toString();
      const cseId = this.sharedService.getActiveFormState().cseId;

      setTimeout(() => {
        (!is304) && (this.leidComponents.toArray()[1].fillLEID(this.sharedService.leid));
        (is304) && (this.leidComponents.toArray()[2].fillLEID(this.sharedService.leid));

        this.sharedService.checkImportBtnRequired(this.sharedService.leid, taxYear, this.sharedService.csStatementId.toString()).pipe(takeUntilDestroyed(this.destroyRef))
          .subscribe((data: boolean) => {
            console.log(data);
            this.showImport = data;
          }, () => {

          }, () => {

          });
      });

      this.startLoader = true;
      this.sharedService.getDSTTrackerRequirementData(taxYear, cseId, formId!).pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe((data: StmtData) => {
        setTimeout(() => {
          this.leidComponents.toArray().forEach((element: TemplateLeidSelectorComponent, index: number) => {
            switch (index) {
              case 0:
                element.fillLEID(data.secondaryleid);
                break;
              case 1:
                element.fillLEID(data.primaryleid);
                break;
            }
          });
        },1000);
        data && this.populateFields(data);

        this.loadCurrency();
      }, () => { this.startLoader = false; }, () => { this.startLoader = false; });
    }else{
      this.nameChangeChecked = true;
    }
  }

  /**
   * Replace the starter blank row with one group per saved description / amount.
   * clear()+push leaves the first input bound to the removed empty group, so a
   * second saved row never shows and the first stays blank.
   */
  private applyAdditionalPropRows(): void {
    const descriptions: string[] = this.attMap['Desc'] || [];
    const basis: string[] = this.attMap['BasisAmt'] || [];
    const fairMarket: string[] = this.attMap['FMVAmt'] || [];
    const count = Math.max(descriptions.length, basis.length, fairMarket.length);
    if (!count) {
      return;
    }
    const rows = Array.from({length: count}, (_value, index) => this.formBuilder.group({
      description: [descriptions[index] ?? ''],
      transferorBasis: [stripAmountFormatting(basis[index])],
      fairMarketVal: [stripAmountFormatting(fairMarket[index])]
    }));
    (this.form184.get('propertiesDetails') as UntypedFormGroup)
      .setControl('additionalPropsDetails', this.formBuilder.array(rows));
    // AppKit projects the input after the first write, so push the saved
    // values again once each row's field exists.
    setTimeout(() => {
      rows.forEach((group, index) => {
        const control = this.additionalPropsDetails?.at(index);
        if (!control) {
          return;
        }
        control.get('description')?.setValue(group.get('description')?.value, {emitEvent: false});
        control.get('transferorBasis')?.setValue(group.get('transferorBasis')?.value, {emitEvent: false});
        control.get('fairMarketVal')?.setValue(group.get('fairMarketVal')?.value, {emitEvent: false});
      });
      this.cdref.detectChanges();
    });
  }

  private applyLiabilityRows(): void {
    const descriptions: string[] = this.attMap['Desc1'] || [];
    const amounts: string[] = this.attMap['BasisAmt1'] || [];
    const count = Math.max(descriptions.length, amounts.length);
    if (!count) {
      return;
    }
    const rows = Array.from({length: count}, (_value, index) => this.formBuilder.group({
      description: [descriptions[index] ?? ''],
      amount: [stripAmountFormatting(amounts[index])]
    }));
    (this.form184.get('liabilitiesAssumed') as UntypedFormGroup)
      .setControl('liabilityDetails', this.formBuilder.array(rows));
    setTimeout(() => {
      rows.forEach((group, index) => {
        const control = this.liabilityDetails?.at(index);
        if (!control) {
          return;
        }
        control.get('description')?.setValue(group.get('description')?.value, {emitEvent: false});
        control.get('amount')?.setValue(group.get('amount')?.value, {emitEvent: false});
      });
      this.cdref.detectChanges();
    });
  }

  populateFields(data: StmtData) : void {
    // Keep every saved value, including blanks, and order each attribute the
    // same way the view does. Skipping nulls shifts BasisAmt/FMVAmt off Desc,
    // so the first property row stays empty and later rows disappear.
    this.attMap = {};
    const grouped = new Map<string, StmtAttrData[]>();
    data.children?.forEach((stmt: StmtAttrData) => {
      const list = grouped.get(stmt.attributeName) ?? [];
      list.push(stmt);
      grouped.set(stmt.attributeName, list);
    });
    grouped.forEach((list, name) => {
      list.sort((a, b) => (Number(a.attributeValueOrder) || 0) - (Number(b.attributeValueOrder) || 0));
      this.attMap[name] = list.map((stmt) =>
        stmt.attributeValue !== undefined && stmt.attributeValue !== null ? stmt.attributeValue : ''
      );
    });
    if (this.attMap['LiquidationDate']) {
      this.attMap['LiquidationDate'].forEach((element: any, index: number) => {
        switch (index) {
          case 0:
            if (element !== '' && element !== undefined) {
              this.defaultDate = this.toDateModel(element);
              this.form184.get('datesTransfer')?.get('dateTransfer1')?.setValue(this.defaultDate);
            }
            break;

          case 1:
            if (element !== '' && element !== undefined) {
              this.liquidationDate2 = this.toDateModel(element);
              this.form184.get('datesTransfer')?.get('dateTransfer2')?.setValue(this.liquidationDate2);
            }
            break;

          case 2:
            if (element !== '' && element !== undefined) {
              this.liquidationDate3 = this.toDateModel(element);
              this.form184.get('datesTransfer')?.get('dateTransfer3')?.setValue(this.liquidationDate3);
            }
            break;
          case 3:
            if (element !== '' && element !== undefined) {
              this.liquidationDate4 = this.toDateModel(element);
              this.form184.get('privateLetterRul')?.get('dateIssued')?.setValue(this.liquidationDate4);
            }
            break;
        }
      });
    }

    this.applyAdditionalPropRows();
    this.applyLiabilityRows();

    if (this.attMap['importationPropertyDesc']) {
      this.importationProp = this.attMap['importationPropertyDesc'];
    }
    if (this.attMap['lossDuplicationPropertyDesc']) {
      this.lossDupProp = this.attMap['lossDuplicationPropertyDesc'];
    }
    if (this.attMap['gainLossPropertyDesc']) {
      this.gainLossAffectedProp = this.attMap['gainLossPropertyDesc'];
    }
    if (this.attMap['CheckFor351Transfer']) {
      this.isSection304Related = parseInt(this.attMap['CheckFor351Transfer'][0]) ? true : false;

    }
    if (this.attMap['ShareX'] && this.attMap['ShareX'][0]) {
      this.sharesBeforeTransfer = this.attMap['ShareX'][0];
    }
    if (this.attMap['ShareY'] && this.attMap['ShareY'][0]) {
      this.sharesAfterTransfer = this.attMap['ShareY'][0];
    }
    if (this.attMap['PercentageX'] && this.attMap['PercentageX'][0]) {
      this.stockBeforeTransfer = this.attMap['PercentageX'][0];
    }
    if (this.attMap['PercentageY'] && this.attMap['PercentageY'][0]) {
      this.stockAfterTransfer = this.attMap['PercentageY'][0];
    }
    if (this.attMap['NoOfShares']) {
      this.amtFromSigTransferor = this.attMap['NoOfShares'];
    }
    if (this.attMap['AmtFor351Transfer'] && this.attMap['AmtFor351Transfer'][0]) {
      this.amtInExchangeFor = this.attMap['AmtFor351Transfer'][0] ?? '';
    }
    if (this.attMap['Para']) {
      this.Para = this.attMap['Para'];
    }

    if (this.attMap['section4text']) {
      this.info = this.attMap['section4text'];
    }

    if (this.attMap['PLR']) {
      this.controlNum = this.attMap['PLR'];
    }
    this.cdref.detectChanges();
    if (this.isSection304Related) {
      if (this.attMap['SHdspTransferorLEID'] !== undefined) {
        this.sharedService.getDSTEntityInfo(this.attMap['SHdspTransferorLEID'][0]).pipe(takeUntilDestroyed(this.destroyRef))
          .subscribe((data: any) => {
            this.leidComponents.toArray()[2].fillLEID(data[0].LEID);
          }, () => {

          }, () => {

          });
      }

      if (data.branchleid) {
        this.leidComponents.toArray()[3].fillLEID(data.branchleid);
      }

    } else if (data.branchleid) {
      this.leidComponents.toArray()[2].fillLEID(data.branchleid);
    }
  }

  check304Section() {
    this.isSection304Related = !this.isSection304Related;
    if (this.isSection304Related) {
      this.form184.get('propertiesDetails')?.get('shareChangeSec')?.get('section304Details')?.get('amtFromSigTransferor')?.setValidators(Validators.required);
    } else {
      this.form184.get('propertiesDetails')?.get('shareChangeSec')?.get('section304Details')?.get('amtFromSigTransferor')?.clearValidators();
    }
    if (this.transferor && this.transferee && (this.selectedBasis !== -1)) {
      this.formInvalid = false;
    }
    this.cdref.detectChanges();
  }

  selectBasisOption(event: any) {
    const selected = Array.isArray(event?.selected) ? event.selected : (event?.selected ? [event.selected] : []);
    const change = selected[0] ?? null;
    this.selectedBasis = change?.value;
    this.selectedBasisName = change?.label ?? change?.text;
    this.selectedBasisItem = change;
    if (this.transferor && this.transferee && (this.selectedBasis !== -1)) {
      this.formInvalid = false;
    }
  }

  selectStockType(event: any) {
    const selected = Array.isArray(event?.selected) ? event.selected : (event?.selected ? [event.selected] : []);
    const change = selected[0] ?? null;
    this.selectedStockType = change?.value;
    this.selectedStockTypeItem = this.stockType[0]?.data?.find((i: any) => String(i.value) === String(change?.value)) || change;
  }

  selectStockType304(event: any) {
    const selected = Array.isArray(event?.selected) ? event.selected : (event?.selected ? [event.selected] : []);
    const change = selected[0] ?? null;
    this.selectedStockType304 = change?.value;
    this.selectedStockType304Item = this.stockType304[0]?.data?.find((i: any) => String(i.value) === String(change?.value)) || change;
  }

  selectExchangeType(event: any) {
    const selected = Array.isArray(event?.selected) ? event.selected : (event?.selected ? [event.selected] : []);
    const change = selected[0] ?? null;
    this.selectedExchangeType = change?.value;
    this.selectedExchangeTypeItem = change;
  }

  OnConsolGroupChanged(consolGroup: DSTConsolGroup): void {
    this.dcnId = consolGroup.DCNID;
  }

  save(): void {

    const trackerTab: TrackerTabState | null = this.trackerTabsService.getActiveTrackerTab();
    if (!trackerTab) {
      return;
    }
    const isPlaceholderChecked: boolean = trackerTab.isPlaceholderChecked;
    if (!this.isFormValid(isPlaceholderChecked) || !this.sharedService.confirmDRE([this.transferor, this.transferee])) {
      return;
    } else {
      this.startLoader = true;
      const formState: DSTFormState = this.sharedService.getActiveFormState();
      const params: { [param: string]: string } = {
        'statementID': this.statementId !== '' ? this.statementId : '0',
        'taxYear': formState.taxYear.toString(),
        'taxYearId': formState.taxYearId.toString(),
        'dcnId': this.dcnId ? toSaveString(this.dcnId) : '',
        'returnPeriodId': formState.returnPeriodId.toString(),
        'formId': formState.formId.toString(),
        'primaryEntityId': safeEntityId(this.transferee),
        'secondaryEntityId': safeEntityId(this.transferor),
        'branchEntityId': safeEntityId(this.branchEntity),
        'comments': this.info || '',
        'placeHolder': isPlaceholderChecked ? '1' : '0',
        'attachmentFileName': '',
        'csStatementId': formState.csStatementId?.toString() || '0',
      };
      const propertyDesc = this.importationProp;
      const lossDupl = this.lossDupProp;
      const gainLossPropertyDesc = this.gainLossAffectedProp;
      const desc: string[] = [];
      const basisAmt: string[] = [];
      const fairMarketVal: string[] = [];
      this.additionalPropsDetails.controls.forEach(element => {
        desc.push(element.value.description);
        basisAmt.push(element.value.transferorBasis !== null ? stripAmountFormatting(element.value.transferorBasis.toString()) : '');
        fairMarketVal.push(element.value.fairMarketVal !== null ? stripAmountFormatting(element.value.fairMarketVal.toString()) : '');
      });
      const desc1: string[] = [];
      const basisAmt1: string[] = [];
      this.liabilityDetails.controls.forEach(element => {
        desc1.push(element.value.description);
        basisAmt1.push(element.value.amount !== null ? stripAmountFormatting(element.value.amount.toString()) : '');
      });
      const currencies = [toSaveString(this.selectedCurrency), toSaveString(this.selectedCurrency2), toSaveString(this.currencySelected3)];
      const shareX = toSaveString(this.sharesBeforeTransfer);
      const shareY = toSaveString(this.sharesAfterTransfer);
      const percentageX = toSaveString(this.stockBeforeTransfer);
      const percentageY = toSaveString(this.stockAfterTransfer);
      const noOfShares = stripAmountFormatting(toSaveString(this.amtFromSigTransferor));
      const amt351 = stripAmountFormatting(toSaveString(this.amtInExchangeFor));
      const para = this.Para;
      const plr = this.controlNum;
      const jsonObject = {
        'statementOption': this.selectedOption === '-' ? '' : this.selectedOption,
        'LiquidationDate': [
          this.formatDateForSave(this.defaultDate),
          this.formatDateForSave(this.liquidationDate2),
          this.formatDateForSave(this.liquidationDate3),
          this.formatDateForSave(this.liquidationDate4)
        ],
        'importationPropertyDesc': propertyDesc[0] ? propertyDesc : '',
        'lossDuplicationPropertyDesc': lossDupl[0] ? lossDupl : '',
        'gainLossPropertyDesc': gainLossPropertyDesc[0] ? gainLossPropertyDesc : '',
        'Basis': toSaveString(this.selectedBasis),
        'Currency': currencies,
        'Desc': desc.some((value) => value !== null && value !== undefined && value !== '') ? desc : [''],
        'BasisAmt': basisAmt,
        'FMVAmt': fairMarketVal,
        'ShareX': shareX,
        'ShareY': shareY,
        'PercentageX': percentageX,
        'PercentageY': percentageY,
        'StockType': this.selectedStockType === -1 ? '' : this.selectedStockType + '',
        'NoOfShares': noOfShares,
        'SHLEID': this.targetLEID?.LEID,
        'SHdspTransferorLEID': safeEntityField(this.targetLEID, 'ENTITYID'),
        'SHBusiness': safeEntityField(this.targetLEID, 'BUSINESSID'),
        'TransfereesNote': this.selectedExchangeType !== 0 ? toSaveString(this.selectedExchangeType) : '',
        'AmtFor351Transfer': amt351,
        'Para': para[0] ? para : '',
        'PLR': plr[0] ? plr : '',
        'Desc1': desc1[0] ? desc1 : [''],
        'BasisAmt1': basisAmt1,
        'section4text': this.info || '',
        'StockType304': this.selectedStockType304 + '',
        'CheckFor351Transfer': this.isSection304Related !== undefined ? (this.isSection304Related ? '1' : '0') : ''
      };

      this.sharedService.saveStatemenet(params, jsonObject).pipe(takeUntilDestroyed(this.destroyRef)).subscribe((data: any) => {
        if (data) {
          this.dstSharedService.showAlert('success', 'Form Save Success!');
          this.startLoader = false;
          this.sharedService.setSavedStatementId(data.statementId);
          const childStatements: any[] = data.childStatement;
          if (childStatements?.length) {
            // overwrite for 304
            const form192: any = childStatements.find((child: any) => child.formId === 192);
            if (form192 && this.isSection304Related) {
              form192.formId = -192;
              form192.statementName = form192.statementName + ' for 304';
            }
            this.sharedService.openChildStatements(childStatements, this.onSave);
          } else {
            this.sharedService.switchTemplateMode(true);
            this.onSave.emit(); // emit without payload -- only notifies tracker to refresh grid
          }
        }
      }, () => {
        this.dstSharedService.showAlert('error', 'Error!');
        this.startLoader = false;
      });
    }
  }

  clear(): void {
    if (this.statementId !== '' && this.statementId !== '0') {
      this.sharedService.switchTemplateMode(true);
    } else {
      this.onCancel.emit();
    }
  }

  onFormOptionChanged(selectedOptionID: number): void {
    const selected: any = this.headerOptions.find((o: any) => {
      return o.value === selectedOptionID || o.id === selectedOptionID;
    });
    this.selectedOption = selected?.label ?? selected?.text;
  }

  onTransferorChanged(selectedTransferor: DSTEntityDetails | null): void {
    this.transferor = selectedTransferor;
    this.form184.controls.datesTransfer.setErrors(null);
    if (this.transferor && this.transferee && (this.selectedBasis !== -1)) {
      this.formInvalid = false;
    }

    this.updateEntitiesName();
    this.DREMsg = this.sharedService.areEntitiesDisregarded([this.transferor!, this.transferee!]);
    this.showDREMsg = !!this.DREMsg;
  }

  private updateEntitiesName(): void {
    if ((this.transferor?.LEID || this.transferee?.LEID) && this.defaultDate) {
      this.entityNameChangeOnDate = true;
      const leids: string = this.sharedService.concatLEIDs([this.transferor!, this.transferee!]);
      if (!leids) {
        return;
      }
      this.startLoader = true;
      this.sharedService.checkForEntityNameChange(this.sharedService.getFormData()?.statementid.toString(),
        leids,
        this.defaultDate,
        this.sharedService.getActiveFormState().taxYear.toString()
      ).pipe(takeUntilDestroyed(this.destroyRef)).subscribe((response: EntityNameChange[]) => {
        if (response && response.length > 0) {
          for (let i = 0; i < leids.split(',').length; i++) {
            if (response[i] && response[i].LEID) {
            this.sharedService.updateEntityName(response[i].LEID,
              response[i].LE_NAME, [this.transferor!, this.transferee!], response[i].TAXTYPECODE);
            } else {
              console.warn(`Response[${i}] is undefined or missing LEID:`, response[i]);
          }
          }
        } else {
          console.warn('Response is empty or undefined:', response);
        }
          this.nameChangeChecked = true;
      }, (error: HttpErrorResponse) => {
        console.log(error);
        this.dstSharedService.showAlert('error', error.message);
      }).add(() => {
        this.startLoader = false;
      });
    }else if(!this.defaultDate) {
      this.nameChangeChecked = true;

    }  else {
      this.entityNameChangeOnDate = false;
    }
  }

  /** Keep saved dates as yyyy-mm-dd. A Date becomes a UTC timestamp in JSON and shifts a day on the next save. */
  private toDateModel(value: any): string {
    if (value === null || value === undefined || value === '') {
      return '';
    }
    const text = String(value).trim();
    if (text.includes('T')) {
      const parsed = new Date(text);
      if (!isNaN(parsed.getTime())) {
        return this.formatDateToYMD(parsed);
      }
    }
    const match = text.match(/^(\d{4})[-/](\d{1,2})[-/](\d{1,2})/);
    if (match) {
      return `${match[1]}-${match[2].padStart(2, '0')}-${match[3].padStart(2, '0')}`;
    }
    return this.formatDateForSave(value);
  }

  private formatDateForSave(value: any): string {
    if (value === null || value === undefined || value === '') {
      return '';
    }
    if (value instanceof Date && !isNaN(value.getTime())) {
      return this.formatDateToYMD(value);
    }
    if (value.startDate && typeof value.startDate.format === 'function') {
      const formatted = value.startDate.format('YYYY-MM-DD');
      return formatted ? String(formatted).substring(0, 10) : '';
    }
    if (typeof value === 'string') {
      const match = value.replace(/T.+/, '').trim().match(/^(\d{4})-(\d{2})-(\d{2})/);
      return match ? `${match[1]}-${match[2]}-${match[3]}` : '';
    }
    return '';
  }

  private hasTransferDate(value: any): boolean {
    return this.formatDateForSave(value) !== '';
  }

  private formatDateToYMD(date: Date): string {
    const y = date.getFullYear();
    const m = String(date.getMonth() + 1).padStart(2, '0');
    const d = String(date.getDate()).padStart(2, '0');
    return `${y}-${m}-${d}`;
  }

  dateChange(event: any, index: number) {
    const formatted = this.formatDateForSave(event);
    if (!formatted) {
      return;
    }
    switch (index) {
      case 1:
        this.defaultDate = formatted;
        this.form184.get('datesTransfer')?.get('dateTransfer1')?.setValue(this.defaultDate);
        this.updateEntitiesName();
        break;

      case 2:
        this.liquidationDate2 = formatted;
        this.form184.get('datesTransfer')?.get('dateTransfer2')?.setValue(this.liquidationDate2);
        break;

      case 3:
        this.liquidationDate3 = formatted;
        this.form184.get('datesTransfer')?.get('dateTransfer3')?.setValue(this.liquidationDate3);
        break;

      case 4:
        this.liquidationDate4 = formatted;
        this.form184.get('privateLetterRul')?.get('dateIssued')?.setValue(this.liquidationDate4);
        this.controlNum = '';
        break;

      default:
        break;
    }
  }
  /**
   * Clear individual date picker by index
   * @param index - Date picker index (1-4)
   */
  clearDate(index: number): void {
    switch (index) {
      case 1:
        this.defaultDate = null;
        this.form184.get('datesTransfer')?.get('dateTransfer1')?.setValue(null);
        this.form184.get('datesTransfer')?.get('dateTransfer1')?.markAsTouched();
        // this.resetEntityNameChange();
        break;
      case 2:
        this.liquidationDate2 = null;
        this.form184.get('datesTransfer')?.get('dateTransfer2')?.setValue(null);
        this.form184.get('datesTransfer')?.get('dateTransfer2')?.markAsTouched();
        break;
      case 3:
        this.liquidationDate3 = null;
        this.form184.get('datesTransfer')?.get('dateTransfer3')?.setValue(null);
        this.form184.get('datesTransfer')?.get('dateTransfer3')?.markAsTouched();
        break;
      case 4:
        this.liquidationDate4 = null;
        this.form184.get('privateLetterRul')?.get('dateIssued')?.setValue(null);
        this.form184.get('privateLetterRul')?.get('dateIssued')?.markAsTouched();
        this.controlNum = '';
        break;
      default:
        break;
    }

    // 🚀 CRITICAL: Force change detection and ensure date picker updates
    console.log('🔄 First detectChanges() called for index:', index);
    this.cdref.detectChanges();

    // Additional clearing step to ensure ap-date-picker component updates
    setTimeout(() => {
      // 🚀 CRITICAL: Force clear date picker input fields if they still show values
      this.forceClearDatePickerInputs(index);
    }, 0);
  }

  /**
   * 🚀 CRITICAL: Force clear date picker input fields using DOM manipulation
   * This is a fallback method for stubborn date picker components
   */
  private forceClearDatePickerInputs(index: number): void {
    try {
      // Find the date picker input field by form control name
      const formControlNames = ['dateTransfer1', 'dateTransfer2', 'dateTransfer3', 'dateIssued'];
      const formControlName = formControlNames[index - 1];

      if (formControlName) {
        // Try to find the input field within the date picker component
        const datePickerElement = document.querySelector(`[formcontrolname="${formControlName}"]`);
        if (datePickerElement) {
          const inputElement = datePickerElement.querySelector('input');
          if (inputElement && inputElement.value) {
            // Clear the input value and trigger change event
            inputElement.value = '';
            inputElement.dispatchEvent(new Event('input', { bubbles: true }));
            inputElement.dispatchEvent(new Event('change', { bubbles: true }));
          }
        }
      }
    } catch (error) {
      console.warn('Error clearing date picker input:', error);
    }
  }

  onTransfereeChanged(selectedTransferee: DSTEntityDetails | null): void {
    this.transferee = selectedTransferee;
    this.form184.controls.datesTransfer.setErrors(null);
    if (selectedTransferee) {
      this.headerComponent.loadConsolGroups(selectedTransferee.LEID,this.dcnId);
      if (this.transferor && this.transferee && (this.selectedBasis !== -1)) {
        this.formInvalid = false;
      }
    }

    this.updateEntitiesName();
    this.DREMsg = this.sharedService.areEntitiesDisregarded([this.transferee!, this.transferor!]);
    this.showDREMsg = !!this.DREMsg;
  }

  onBranchEntityChanged(selectedBranch: DSTEntityDetails | null): void {
    this.branchEntity = selectedBranch;
  }

  onTransferLEIDChanged(selectedBranch: DSTEntityDetails | null): void {
    this.targetLEID = selectedBranch;
  }

  addAdditionalPropDetails(): void {
    this.additionalPropsDetails.push(this.formBuilder.group({
      description: [''],
      transferorBasis: [''],
      fairMarketVal: ['']
    }));
  }

  removeAdditionalPropDetailsAt(index: number): void {
    this.additionalPropsDetails.removeAt(index);
  }

  addLiabilityDetails(): void {
    this.liabilityDetails.push(this.formBuilder.group({
      description: [''],
      amount: ['']
    }));
  }

  removeLiabilityDetailsAt(index: number): void {
    this.liabilityDetails.removeAt(index);
  }

  dummyFunc(event: any): void {

  }

  currencyOneChange(event: any): void {
    const selected = Array.isArray(event?.selected) ? event.selected : (event?.selected ? [event.selected] : []);
    const change = selected[0] ?? null;
    this.selectedCurrency = change?.value;
    this.selectedCurrencyItem = change;
    const sourceData = this.currencyOptions[0]?.data ?? [];
    this.currencyOptions2[0].data = safeJsonInput<any>(JSON.stringify(sourceData), null, 'template-sec351-id184.parse5');
    this.selectedCurrency2 = change?.value;
    this.selectedCurrencyItem2 = this.currencyOptions2[0]?.data?.find((i: any) => i.value === change?.value) || null;
  }

  currencyTwoChange(event: any): void {
    const selected = Array.isArray(event?.selected) ? event.selected : (event?.selected ? [event.selected] : []);
    const change = selected[0] ?? null;
    this.selectedCurrency2 = change?.value;
    this.selectedCurrencyItem2 = change;
  }

  selectedCurrency3(event: any): void {
    const selected = Array.isArray(event?.selected) ? event.selected : (event?.selected ? [event.selected] : []);
    const change = selected[0] ?? null;
    this.currencySelected3 = change?.value;
    this.selectedCurrencyItem3 = change;
  }

  cancel(): void {

  }

  onChangeNumber(event: any, index: number): void {
    const numeric = String(event?.value ?? '').replace(/[^0-9.-]/g, '');
    this.additionalPropsDetails.at(index).get('fairMarketVal')?.setValue(numeric);
  }

  import(): void {
    this.startLoader = true;
    this.sharedService.getImport(this.transferee?.LEID, this.sharedService.getActiveFormState()?.taxYear, this.sharedService.getTransDateStr(this.defaultDate)).pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe((data: any) => {
        console.log(data);
        if (data.length) {
          this.additionalPropsDetails.clear();
          data.forEach((element: any) => {
            this.additionalPropsDetails.push(this.formBuilder.group({
              description: [element.DESCRIPTION],
              transferorBasis: [element.AMOUNTS],
              fairMarketVal: [element.AMOUNTS]
            }));
            this.totalCalc += element.AMOUNTS;
          });
          this.showImport = false;
          this.showTotal = true;
          // this.propertyValBasisOptions[0].data[2].selected = true;

        }
        this.startLoader = false;
      }, () => {

      }, () => {

      });
  }

  total(event: any): void {
    this.additionalPropsDetails.clear();
    const isChecked = event?.checkboxState ?? event?.srcElement?.checked ?? false;
    if (isChecked) {
      this.additionalPropsDetails.push(this.formBuilder.group({
        description: ['Net Assets'],
        transferorBasis: [this.totalCalc],
        fairMarketVal: [this.totalCalc]
      }));
    } else {
      this.totalCalc = 0;
      this.import();
    }
  }

  onDPOpen(): void { // styling fix for gtw-ui
    const modalEle: Element | null = document.querySelector('ngx-daterangepicker-material');
    modalEle?.classList.add('gtw-web-components');
  }

  isFormValid(placeholder: boolean): boolean {
    if (!this.hasTransferDate(this.defaultDate)
      && !this.hasTransferDate(this.liquidationDate2)
      && !this.hasTransferDate(this.liquidationDate3)) {
      this.dstSharedService.showAlert('error', 'Please specify the Transaction date');
      return false;
    }
    if (placeholder) {
      if (!this.transferee) {
        this.dstSharedService.showAlert('error', 'Please specify the Transferee');
        return false;
      }
    } else {
      if (!this.transferee) {
        this.dstSharedService.showAlert('error', 'Please specify the Transferee');
        return false;
      }
      if (!this.transferor) {
        this.dstSharedService.showAlert('error', 'Please specify the Transferor');
        return false;
      }

      if (this.selectedCurrency === 0) {
        this.dstSharedService.showAlert('error', 'Please select Fair Market value Currency type');
        return false;
      }
      if (this.selectedBasis === -1) {
        this.dstSharedService.showAlert('error', 'Please select a Basis section');
        return false;
      }

      if (this.sharesBeforeTransfer && this.sharesAfterTransfer && this.sharesBeforeTransfer != this.sharesAfterTransfer) {
        if (!this.stockBeforeTransfer || !this.stockAfterTransfer) {
          this.dstSharedService.showAlert('error', 'Please enter percentages or delete number of shares in Share/Change ownership information section');
          return false;
        }
      }

      if (this.isSection304Related) {
        if (this.amtFromSigTransferor === '') {
          this.dstSharedService.showAlert('error', 'Please specify Number Of Shares for 304 transactions');
          return false;
        }
        if (this.selectedStockType304 === 0) {
          this.dstSharedService.showAlert('error', 'Please specify Stock Type for 304 transactions');
          return false;
        }
        if (!this.targetLEID) {
          this.dstSharedService.showAlert('error', 'Please specify Target/Acquired LEID for 304 transactions');
          return false;
        }
        if (this.selectedExchangeType === 0) {
          this.dstSharedService.showAlert('error', 'Please specify in exchange of for 304 transactions');
          return false;
        }
        if (!this.amtInExchangeFor) {
          this.dstSharedService.showAlert('error', 'Please specify in the amount of for 304 transactions');
          return false;
        }
        if (this.currencySelected3 === 0) {
          this.dstSharedService.showAlert('error', 'Please select Currency for 304 transactions');
          return false;
        }
      }
    }

    return true;
  }

  setAriaLabel(item: any, contextLabel: string = 'Option'): string {
    const label = item?.label || item?.text || '-';
    return `${contextLabel} option ${label}`.trim();
  }

  onDropdownSelectItem(event: any): void {
  }
}
